// Import images
import BankOfAmerica from "../images/projects/bank-of-america.png";
import ChaseChecking from "../images/projects/chase-checking.png";
import NeimanMarcus from "../images/projects/neiman-marcus.png";
import ChaseCards from "../images/projects/chase-cards.png";
import Aes from "../images/projects/aes.png";
import GO7 from "../images/projects/go7.png";

export const projectsData = [
  {
    id: 6,
    title: "GO7",
    category: "Web Application",
    description: "Modular Airline Technology Solutions",
    img: GO7,
    url: "https://www.go7.io/partners/airlines",
  },
  {
    id: 1,
    title: "Bank of America",
    category: "Web Application",
    description: "AG-GRIDS",
    img: BankOfAmerica,
    url: "https://www.bankofamerica.com",
  },
  {
    id: 2,
    title: "JPMorgan Chase Personal",
    category: "Web Application",
    description: "Customer Credit History",
    img: ChaseChecking,
    url: "https://personal.chase.com/personal/checking",
  },
  {
    id: 3,
    title: "JPMorgan Chase Credit-Cards",
    category: "Web Application",
    description: "Customer Rewards Points",
    img: ChaseCards,
    url: "https://creditcards.chase.com/rewards-credit-cards",
  },
  {
    id: 4,
    title: "Neiman Marcus",
    category: "Web Application",
    description: "Login Page",
    img: NeimanMarcus,
    url: "https://www.neimanmarcus.com/login",
  },
  {
    id: 5,
    title: "AES Corporation",
    category: "Web Application",
    description: "New Clean Energy Project",
    img: Aes,
    url: "https://www.aes.com/products/our-offerings/new-clean-energy",
  }
];
